<template>
  <div v-if="isExternalLink">
    <a :href="url" :class="classList">
      <i :class="icon"></i> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
    </a>
  </div>
  <div v-else>
    <router-link :to="url" @click.native="toggleSideBar()" :class="classList">
      <i :class="icon"></i> {{name}}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{badge.text}}</b-badge>
      <b-badge v-if="noOfOrdersWaitingForAdminDeliveryDetails != ''" variant="danger">{{ noOfOrdersWaitingForAdminDeliveryDetails }}</b-badge>
      <b-badge v-if="noOfOrdersWaitingForAdminRejectedByPharmacy != ''" variant="danger">{{ noOfOrdersWaitingForAdminRejectedByPharmacy }}</b-badge>
      <b-badge v-if="noOfOrdersPaymentFailed != ''" variant="danger">{{ noOfOrdersPaymentFailed }}</b-badge>
    </router-link>
  </div>
</template>

<script>
  export default {
    name: 'sidebar-nav-link',
    props: {
      name: {
        type: String,
        default: ''
      },
      url: {
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      badge: {
        type: Object,
        default: () => {}
      },
      variant: {
        type: String,
        default: ''
      },
      classes: {
        type: String,
        default: ''
      },
      noOfOrdersWaitingForAdminDeliveryDetails: {
        default: ''
      },
      noOfOrdersWaitingForAdminRejectedByPharmacy: {
        default: ''
      },
      noOfOrdersPaymentFailed: {
        default: ''
      }
    },
    computed: {
      classList () {
        return [
          'nav-link',
          this.linkVariant,
          ...this.itemClasses
        ]
      },
      linkVariant () {
        return this.variant ? `nav-link-${this.variant}` : ''
      },
      itemClasses () {
        return this.classes ? this.classes.split(' ') : []
      },
      isExternalLink () {
        if (this.url.toString().substring(0, 4) === 'http') {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      toggleSideBar () {
        var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        if (w < 992) {
          document.body.classList.toggle('sidebar-hidden');
        }
      }
    }
  }
</script>
